/**
 * UnreserveConfirmationModal - Tipo 1: Modal de Confirmación
 */

import React from 'react';
import { LockOpen as UnlockIcon } from '@mui/icons-material';
import BlockActionConfirmationModal from './BlockActionConfirmationModal';

export interface UnreserveConfirmationModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: (comment?: string) => void;
  itemName?: string;
  itemCode?: string;
  isLoading?: boolean;
  title?: string;
  message?: string;
}

const UnreserveConfirmationModal: React.FC<UnreserveConfirmationModalProps> = ({
  open,
  onClose,
  onConfirm,
  itemName,
  itemCode,
  isLoading = false,
  title = 'Confirmar liberación de bloqueo',
  message = '¿Liberar el bloqueo de esta pieza?',
}) => (
  <BlockActionConfirmationModal
    open={open}
    onClose={onClose}
    onConfirm={onConfirm}
    itemName={itemName}
    itemCode={itemCode}
    isLoading={isLoading}
    title={title}
    message={message}
    confirmText="Confirmar"
    loadingConfirmText="Liberando..."
    icon={<UnlockIcon />}
    commentPlaceholder="Ej: Motivo de liberación del bloqueo"
  />
);

export default UnreserveConfirmationModal;
